<template>
  <div class="l-task-week">
    <div class="left">
      <h5 class="l-week">第{{week.weekId }}周</h5>
      <span class="l-time">{{ week.startTime}} ~ {{week.endTime }}</span>
    </div>
    <div class="right">
      <label v-if="!week.isFirst" @click="onToggle(-1)" class="l-event">上一周</label>
      <label v-if="!week.isLast" @click="onToggle(1)" class="l-event">下一周</label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    week: [Object],
  },

  methods: {
    onToggle(changeNum) {
      this.$emit('toggle', changeNum)
    },
  },
}
</script>

<style lang="stylus" scoped>
.l-task-week
  display flex
  justify-content space-between
  align-items center
  font-size 14px
  width 100%
  box-sizing border-box
  height 60px
  .l-week
    display inline-block
    font-size 20px
    padding 0
    margin 0
    margin 0 8px 0 0
    .l-time
      font-size 16px
  .right
    label
      cursor pointer
      display inline-block
      font-size 14px
      background-color rgba(255, 255, 255, 0.2)
      height 30px
      line-height 30px
      padding 0 18px
      margin 0
      border-radius 30px
      &:last-child
        margin-left 10px
</style>